var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 74,
    viewBox: "0 0 64 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.916 3.69768C16.3981 9.00027 16.6832 14.4906 16.6832 19.808C16.6832 26.3053 16.9746 32.9153 16.4132 39.3706C15.4607 50.3244 16.4275 61.0366 16.4275 71.9748",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85156 38.7313C4.16538 38.7313 6.61273 38.8399 8.81282 38.163C10.9992 37.4903 13.9853 37.9641 16.2855 37.9641C18.8133 37.9641 21.2897 37.7084 23.8434 37.7084C25.8567 37.7084 27.7117 37.9641 29.725 37.9641",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8448 2.31674C27.8448 17.5674 28.0296 32.7877 28.0296 48.0369C28.0296 52.7517 27.6601 57.438 27.6601 62.141C27.6601 64.7759 27.4753 67.3998 27.4753 70.0347C27.4753 70.7433 27.4694 70.0724 27.4753 69.7165C27.4925 68.6865 27.6601 67.6748 27.6601 66.637C27.6601 63.6073 27.8448 60.5882 27.8448 57.5731C27.8448 54.4132 27.9331 51.2242 29.0356 48.2319C30.751 43.5757 34.6107 39.8497 39.5264 38.7574C44.1753 37.7243 49.5887 37.7148 53.8563 40.1534C55.047 40.8338 56.1813 41.2404 56.8536 42.5143C57.5235 43.7836 58.314 45.012 59.0298 46.2508C59.9488 47.8415 60.3123 49.7051 60.7338 51.4654C61.2286 53.5321 61.9902 55.6847 62.0272 57.8297C62.1086 62.553 62.2119 67.2457 62.2119 71.9748",
    stroke: "#EE2B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/TH.135c5cee90468bd9c5fbc348e3ed9fc3.svg";
export { ForwardRef as ReactComponent };